import { vendorSubHireUpload } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getVendorSubHireUploadList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(vendorSubHireUpload.vendorSubHireUploadBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getVendorSubHireUploadObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vendorSubHireUpload.vendorSubHireUploadBase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  createVendorSubHireUpload(formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(vendorSubHireUpload.vendorSubHireUploadBase, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  downloadSampleFile() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vendorSubHireUpload.vendorSubHireUploadBase}sample_file/`, {
          responseType: "blob",
        })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
  getAdminVendorSubHireUploadList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(vendorSubHireUpload.adminVendorSubHireUploadBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getAdminVendorSubHireUploadObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vendorSubHireUpload.adminVendorSubHireUploadBase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  createAdminVendorSubHireUpload(formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(vendorSubHireUpload.adminVendorSubHireUploadBase, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  downloadAdminSampleFile() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vendorSubHireUpload.adminVendorSubHireUploadBase}sample_file/`, {
          responseType: "blob",
        })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
  getUploadMonitorStats(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vendorSubHireUpload.adminVendorSubHireUploadBase}monitor/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getUploadMonitorJobs(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${vendorSubHireUpload.adminVendorSubHireUploadBase}monitor_jobs/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  approveDraftJob(id, remarks) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${vendorSubHireUpload.adminVendorSubHireDraftJobBase}${id}/approve/`, { remarks })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  rejectDraftJob(id, remarks) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${vendorSubHireUpload.adminVendorSubHireDraftJobBase}${id}/reject/`, { remarks })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  editDraftJobItem(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${vendorSubHireUpload.adminVendorSubHireDraftJobItemBase}${id}/edit/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  rejectDraftJobItem(id, remarks) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${vendorSubHireUpload.adminVendorSubHireDraftJobItemBase}${id}/reject/`, { remarks })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  refreshDraftJobRate(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${vendorSubHireUpload.adminVendorSubHireDraftJobBase}${id}/refresh_rate/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  editVendorDraftJobItem(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${vendorSubHireUpload.vendorSubHireDraftJobItemBase}${id}/edit/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  rejectVendorDraftJobItem(id, remarks) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${vendorSubHireUpload.vendorSubHireDraftJobItemBase}${id}/reject/`, { remarks })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
